import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 align="center">Amazing React Charts</h1>
    <div align="center">
 UI toolkit for the web.

    </div>
    <p>{`A simple library to create and handling awesome canvas charts. `}</p>
    <p>{`This package is based on echarts and echarts-for-react wrapper.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`Amazing React Charts is avaliable as a `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/amazing-react-charts"
      }}>{`NPM`}</a>{` package.`}</p>
    <ul>
      <li parentName="ul">{`With npm:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`    npm install --save amazing-react-charts
`}</code></pre>
    <ul>
      <li parentName="ul">{`With yarn:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`    yarn add amazing-react-charts
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Here is a quick example to get you started, `}<strong parentName="p">{`it's all you need`}</strong>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import VerticalBarChart from 'amazing-react-charts'

<VerticalBarChart
    color='green'
    xType='time'
    barWidth={ 100 }
    yComplement='%'
    tooltip={{ 
        label: 'Axis x tooltip label',
        result: 'Axis y tooltip label'
    }}
    data={[
        { label: 'value 1', result: 50 },
        { label: 'value 2', result: 21 },
        { label: 'value 3', result: 84 },
        { label: 'value 4', result: 79 }
    ]}
/>

`}</code></pre>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <p>{`To run the demo:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`git clone https://github.com/nginformatica/amazing-react-charts.git

yarn && yarn start
`}</code></pre>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`AreaChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`HorizontalBarChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`StackedBarChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`VerticalBarChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`PieChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`CoordinateLineChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`DonutChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`LineChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`PictorialChart`}</li>
    </ul>
    <h2 {...{
      "id": "special-components"
    }}>{`Special Components`}</h2>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`AudiometryChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`ForecastAreaChart`}</li>
    </ul>
    <h2 {...{
      "id": "next-components"
    }}>{`Next Components`}</h2>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`CalendarChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`ClusteredBarChart`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`RadarChart`}</li>
    </ul>
    <h2 {...{
      "id": "documentation"
    }}>{`Documentation`}</h2>
    <p>{`Check out our `}<a parentName="p" {...{
        "href": "https://amazing-react-charts.now.sh/"
      }}>{`documentation website`}</a>{`.`}</p>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`Bug reports, feature requests and other contributions are more than welcome! `}<br />{`
Whenever possible, please make a pull request with the implementation instead of just requesting it.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If the feature is big, open an issue first for discussion.`}</p>
    </blockquote>
    <p>{`The descriptions of the props used on this package are found in: `}<a parentName="p" {...{
        "href": "https://echarts.apache.org/en/option.html"
      }}>{`https://echarts.apache.org/en/option.html`}</a></p>
    <h2 {...{
      "id": "license"
    }}>{`License`}</h2>
    <p>{`This project is licensed under the terms of the
`}<a parentName="p" {...{
        "href": "/LICENSE"
      }}>{`MIT license`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      